import * as React from "react";
const SearchIcon = (props: any) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={32}
    height={32}
    fill="none"
    {...props}
  >
    <g clipPath="url(#a)">
      <mask
        id="b"
        width={32}
        height={32}
        x={0}
        y={0}
        maskUnits="userSpaceOnUse"
        style={{
          maskType: "luminance",
        }}
      >
        <path fill="#fff" d="M32 0H0v32h32V0Z" />
      </mask>
      <g mask="url(#b)">
        <mask
          id="c"
          width={32}
          height={32}
          x={0}
          y={0}
          maskUnits="userSpaceOnUse"
          style={{
            maskType: "luminance",
          }}
        >
          <path fill="#fff" d="M32 0H0v32h32V0Z" />
        </mask>
        <g fill="#fff" mask="url(#c)">
          <path d="m23.281 21.665-4.526-4.489a.489.489 0 0 1-.124-.409 5.697 5.697 0 1 0-1.227 1.214.498.498 0 0 1 .413.123l4.535 4.498a.352.352 0 0 0 .496-.003l.435-.44a.352.352 0 0 0-.002-.495m-9.213-3.917a4.38 4.38 0 1 1-.018-8.761 4.38 4.38 0 0 1 .018 8.761Z" />
          <path d="M16 0a16 16 0 1 0 0 32 16 16 0 0 0 0-32ZM6.131 27.156A33.794 33.794 0 0 1 16 25.72a33.8 33.8 0 0 1 9.87 1.434 14.893 14.893 0 0 1-19.738 0m20.4-.623-.196.19A34.214 34.214 0 0 0 16 25.17c-3.505-.015-6.99.51-10.336 1.554-.066-.063-.132-.126-.196-.19a14.895 14.895 0 1 1 21.064 0" />
        </g>
      </g>
    </g>
    <defs>
      <clipPath id="a">
        <path fill="#fff" d="M0 0h32v32H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SearchIcon;
